import React from 'react';

const RiskBadge = ({ isAlert, isHibp, isMention }) => {
  if (isMention) {
    return (
      <span className="ml-2 px-1.5 py-0.5 bg-amber-100 text-amber-950 border border-amber-400/80 rounded text-[8px] font-black uppercase tracking-wider">
        Mention
      </span>
    );
  }
  if (!isAlert && !isHibp) {
    return (
      <span className="ml-2 px-1.5 py-0.5 bg-emerald-50 text-emerald-600 border border-emerald-100 rounded text-[8px] font-black">
        ✓ VERIFIED
      </span>
    );
  }

  return (
    <span className={`ml-2 px-1.5 py-0.5 border rounded text-[8px] font-black ${isHibp ? 'bg-red-200 border-red-300 text-red-800' : 'bg-emerald-50 border-emerald-100 text-emerald-600'}`}>
      {isHibp ? 'CRITICAL BREACH' : 'RISK ALERT'}
    </span>
  );
};

export default RiskBadge;
